import React from 'react';
// import './css/Common-Loader.css'

function CommonLoader() {
    return (
        <div className="Loading d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default CommonLoader